import { useTheme } from "next-themes";

function useAppTheme() {
  const { resolvedTheme } = useTheme();
  return resolvedTheme === "dark" ? "dark" : "light";
}

export { useAppTheme };
